<template>
    <section class="relative aqua-background ">
        <div class="section-large text-with-image container">
            <div class="text-with-image-text">
                <div class="deadline-illustration mbs mts">
                    <div class="narrow-text">
                    <h2>Full programme now available</h2>
                    <q-btn href="https://www.utaresources.mmu.ac.uk/leed-conference-23/#/programme" color="primary" text-color="white" label="See full programme"  no-caps class="full-width" />
                    </div>
                </div>
                <div class="deadline-timer-container narrow-text">
                
                    <p><b>Time left until the conference opens:</b></p>
                    <div class="deadline-timer relative">
                        <div class="countdown countdown-days">
                            <div>
                                <div class="countdown-label">Days</div>
                                <div class="countdown-number">{{ textDay }}</div>
                            </div>
                        </div>
                        <div class="countdown countdown-hours">
                            <div>
                                <div class="countdown-label">Hours</div>
                                <div class="countdown-number">{{ textHour }}</div>
                            </div>
                        </div>
                        <div class="countdown countdown-minutes">
                            <div>
                                <div class="countdown-label">Minutes</div>
                                <div class="countdown-number">{{ textMinute }}</div>
                            </div>
                        </div>
                        <div class="countdown countdown-seconds">
                            <div>
                            <div class="countdown-label">Seconds</div>
                            <div class="countdown-number">{{ textSecond }}</div>
                            </div>
                        </div>
                        <div class="deadline-timer-background">
                        <!-- <img src="../assets/291.svg" alt=""> -->
                        </div>
                    </div>
                </div>
            </div>
             <div class="text-with-image-img mts"><img src="../assets/291.svg" alt=""></div>
        </div>    
        <div class="deadline-divider">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
            </svg>
            <!-- <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
            </svg> -->
        </div> 
    </section> 
</template>

<script setup>

    import { ref } from 'vue'
    import { date } from 'quasar'

    let textDay = ref(0)
    let textHour = ref(0)
    let textMinute = ref(0)
    let textSecond = ref(0)

    const date1 = ref(new Date().getTime())
    const date2 = ref(new Date('march 31, 2023 11:59:00'))
    const unit = ref('months')

    const diff = ref(date.getDateDiff(date2.value, date1.value, unit.value))
    // `diff` is 34 (days)
  
    const countdown = () => {
      
        const submissionCountDate = ref(new Date('June 14, 2023 09:30:00').getTime());
        // const submissionCountDate = ref(new Date('March 31, 2023 11:59:00').getTime());

        const now = ref(new Date().getTime())

        const submissionDeadlineGap = ref(submissionCountDate.value - now.value)

        const second = ref(1000)
        const minute = ref(second.value * 60)
        const hour = ref(minute.value * 60)
        const day = ref(hour.value * 24)

        textDay.value = submissionDeadlineGap.value >= 0 ? Math.floor(submissionDeadlineGap.value / day.value) : 0;
        textHour.value = submissionDeadlineGap.value >= 0 ? Math.floor((submissionDeadlineGap.value % day.value) / hour.value) : 0 
        textMinute.value = submissionDeadlineGap.value >= 0 ? Math.floor((submissionDeadlineGap.value % hour.value) / minute.value) : 0
        textSecond.value = submissionDeadlineGap.value >= 0 ? Math.floor((submissionDeadlineGap.value % minute.value) / second.value) : 0

    };

    countdown()

    setInterval(countdown, 1000);

</script>



